import { Component } from '@angular/core';
import { ActiveCartFacade, OrderEntry } from '@spartacus/cart/base/root';
import { RoutingService } from '@spartacus/core';
import { filter, Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'knbr-cwt-empty-cart-component',
    templateUrl: './cwt-empty-cart-component.component.html',
    styleUrl: './cwt-empty-cart-component.component.scss',
    imports: [AsyncPipe]
})
export class CwtEmptyCartComponentComponent {
  entries$: Observable<OrderEntry[]>;
  constructor(protected activeCartService: ActiveCartFacade, protected routingService: RoutingService) { }
  ngOnInit() {
    this.entries$ = this.activeCartService
      .getEntries()
      .pipe(filter((entries) => entries.length >= 0));
    this.entries$.subscribe((entries) => {
    });

  }

  navigate(url: string) {
    this.routingService.goByUrl(url);
  }
}
